export default __webpack_public_path__ + "static/media/swap.2ce4ed39.svg";